import env from 'env';

const LOCAL_SERVER_URL = env.REACT_APP_SERVER_URL;

export const checkLocalServerRunning = async (): Promise<boolean> => {
  if (!env.IS_LOCAL) {
    return true;
  }
  try {
    const response = await fetch(`${LOCAL_SERVER_URL}/ping`);
    if (!response.ok) {
      // i18n-ok: local development only
      alert('Failed connecting to local server');
      return false;
    }
    return true;
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    console.error(`Server check failed: ${message}`);
    // i18n-ok: local development only
    alert('Failed connecting to local server');
    return false;
  }
};
